import { render, staticRenderFns } from "./BorderButton.vue?vue&type=template&id=990b8d52&scoped=true&"
import script from "./BorderButton.vue?vue&type=script&lang=js&"
export * from "./BorderButton.vue?vue&type=script&lang=js&"
import style0 from "./BorderButton.vue?vue&type=style&index=0&id=990b8d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990b8d52",
  null
  
)

export default component.exports